import { HOME, ABOUT_US_TITLES, INVESTORS, RELEVANT_INFO_TITLES, } from '@constants/titles.constant';

export const ABOUT_US_BREADCRUMBS: Array<string> = [HOME, ABOUT_US_TITLES.name];
export const RELEVANT_INFORMATION_BREADCRUMBS: Array<string> = [HOME, RELEVANT_INFO_TITLES.name];
export const INVESTORS_BREADCRUMBS: Array<string> = [HOME, INVESTORS];
export const POLICIES_STATUTES_BREADCRUMBS: Array<string> = [HOME, INVESTORS];
export const GENERALI_GROUP_BREADCRUMBS: Array<string> = [HOME, 'Quiénes somos', 'Grupo Generali'];
